// extracted by mini-css-extract-plugin
export default {"root":"ScreenLoader_root__TNFYS"};